// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__TbRXE","modal__content":"Modal_modal__content__Z5P3l","header":"Modal_header__li25J","header__close":"Modal_header__close__y1z+j"};